app.service('ajaxOverwrite', function (modal, loading, console, front, cookie, broker) {

	var customerAccountCaptchaRequiredUrls = [
		"/customer-esd-codes.ltr",
		"/customer-order-cancel.ltr",
		"/customer-order-cancel-reason.ltr",
		"/customer-remove-delivery-address.ltr",
		"/customer-set-default-delivery-address.ltr",
		"/customer-set-default-receiver-data.ltr",
		"/customer-erp-order-print.ltr",
		"/customer-set-default-invoice-address.ltr",
		"/customer-order-email.ltr",
		"/customer-delivery-address-edit.ltr",
		"/customer-receiver-data-edit.ltr",
		"/customer-invoice-data-edit.ltr",
		"/customer-remove-invoice-address.ltr",
		"/customer-all-complaints.ltr",
		"/customer-order-complaints.ltr",
		"/customer-order-complaint-details.ltr",
		"/customer-reclamation-request.ltr",
		"/customer-return-request.ltr",
		"/customer-remove-receiver-data.ltr",
		"/customer-order-document-download.ltr",
		"/customer-esd-codes-print-view.ltr",
		"/customer-order-delivery-time.ltr",
		"/customer-change-payment-type-additional-sections.ltr",
		"/customer-subscription-products-list.ltr",
		"/customer-subscription-service-contract-close.ltr",
		"/customer-subscription-service-contract-close-reason.ltr",
		"/customer-subscription-service-contract-details.ltr",
		"/customer-subscription-payment-change-token.ltr",
		"/customer-subscription-warranty-payment-list.ltr",
		"/customer-warranty-subscription-close.ltr",
		"/customer-warranty-subscription-close-reason.ltr",
		"/customer-subscription-service-contract-activity.ltr",
		"/customer-subscription-invoice-data-update.ltr"];

	if (document.location.search && document.location.search.indexOf('ucm-scripts') > -1) {
		$.ajaxSetup({
			data: {
				'ucm-scripts': 'off'
			}
		});
		$().ready(function() {
			$("a[href*='.bhtml']").each(function(i, n) {
				var href = $(n).attr('href').replace('.bhtml?', '.bhtml&').replace('.bhtml', '.bhtml?ucm-scripts=off');
				$(n).attr('href', href);
			});
		})
	}

	if (document.location.search && document.location.search.indexOf('ucm-scripts') > -1) {
		$.ajaxSetup({
			data: {
				'ucm-scripts': 'off'
			}
		});
	}
	if (document.location.search && document.location.search.indexOf('ucm-cache') > -1) {
		$.ajaxSetup({
			data: {
				'ucm-cache': 'off'
			}
		});
	}
	$(document).on('ajaxSuccess', function(event, jqXHR, settings) {
		console.log('Sukces: '+settings.url)
	})
	$(document).on('ajaxError', function(event, jqXHR, settings, thrownError) {
		if (thrownError !== "abort" && settings.url.indexOf('/shopEvent.ltr') == -1 && (settings.url.indexOf('.ltr') > -1 || settings.url.indexOf('.bhtml') > -1)) {
			app.logEvent({
				id: 'error-ajax',
				f03: settings.url.indexOf('?') > -1 ? settings.url.substr(0, settings.url.indexOf('?')) : settings.url,
				f04: front.page(),
				f05: cookie.get('JSESSIONID')
			});
			UA.interaction('Monitoring', 'Błąd ajaxa', document.location.href);
		}
		console.log('Błąd ajaxa: ' + settings.url, jqXHR, thrownError);
		
		var statusCode = jqXHR.status;
		var header = jqXHR.getResponseHeader('CSRF_ERROR');
		var backend = jqXHR.getResponseHeader('x-backend');

		if (statusCode === 403 && customerAccountCaptchaRequiredUrls.includes(settings.url.split("?")[0])) {
			broker.trigger('403_ACCOUNT');
		}
		else if (header) {
			if (statusCode === 403) {
				modal.alert("Wystąpił błąd, spróbuj ponownie później.", function() {
					loading.reload();
				});
			} else if (statusCode === 401) {
				modal.alert("Zostałeś wylogowany, zaloguj się ponownie.", function() {
					loading.reload();
				});
			}
		} else {
			if ((statusCode === 403 || statusCode === 401) && settings.url.indexOf('customer_j_spring_security_check.ltr') == -1 && settings.url.indexOf('/shopEvent.ltr') == -1) {
				if (backend) {
					modal.alert("Twoja sesja wygasła. Prosimy zalogować się ponownie.", function () {
						loading.reload();
					});
				} else { 
					console.info('Zablokowane żądanie');
				}
			}
		}
	});
	var token;
	var header;
	$.ajaxSetup({
		beforeSend: function(request, settings) {
			var $meta;
			if(!token && !header){
				$meta = $("meta[name='_csrf']");
				if($meta.length){
					token = $meta.attr("content");
					$meta = $("meta[name='_csrf_header']");
					header = $meta.attr("content");
				}
			}
			if (token && header) {
				request.setRequestHeader(header, token);
			} else {
				var $input = $("input[name='_csrf']:last");
				if ($input.length) {
					request.setRequestHeader('X-CSRF-TOKEN', $input.val());
				}
			}
			if(settings && settings.url){
				console.log('Wysyłanie ajaxa: '+ settings.url);
			}
		}
	});
});
